<template>
    <gridComponent :loader="loader" :items="items" :itemsData="itemsData" :headers="headers"
        :colonneWidth="colonneWidth" :GetFunction="fetchDeliveryOrders">

        <template v-slot:[SlotsFilters.Filter1]="{ index }">
            <ColumnFilter :title="$t('Delivery.deliveryPersonId')" :Filter="filters.SearchTitle"
                :getList="fetchDeliveryPersons" @cancel="filters.SearchDeliveryPersonId = null" :index="index">
                <template v-slot:input>
                    <v-text-field v-model="filters.SearchTitle" id="deliveryPersonId" variant="outlined" maxlength="50"
                        hide-details></v-text-field>
                </template>
            </ColumnFilter>
        </template>

        <template v-slot:[SlotsFilters.Filter2]="{ index }">
            <ColumnFilter :title="$t('Delivery.fullName')" :Filter="filters.SearchFullName"
                :getList="fetchDeliveryPersons" @cancel="filters.SearchFullName = null" :index="index">
                <template v-slot:input>
                    <v-text-field v-model="filters.SearchFullName" id="fullName" variant="outlined" maxlength="50"
                        hide-details></v-text-field>
                </template>
            </ColumnFilter>
        </template>

        <template v-slot:[SlotsFilters.Filter3]="{ index }">
            <ColumnFilter :title="$t('Delivery.phone')" :Filter="filters.SearchPhone" :getList="fetchDeliveryPersons"
                @cancel="filters.SearchPhone = null" :index="index">
                <template v-slot:input>
                    <v-text-field v-model="filters.SearchPhone" id="phone" variant="outlined" maxlength="15"
                        hide-details></v-text-field>
                </template>
            </ColumnFilter>
        </template>

        <template v-slot:[SlotsFilters.Filter4]="{ index }">
            <ColumnFilter :title="$t('Delivery.status')" :Filter="filters.SearchIsActive"
                :getList="fetchDeliveryPersons" @cancel="filters.SearchIsActive = null" :index="index">
                <template v-slot:input>
                    <v-select v-model="filters.SearchIsActive" :items="[true, false]"
                        :item-title="item => (item ? $t('common.active') : $t('common.inactive'))" variant="outlined"
                        hide-details></v-select>
                </template>
            </ColumnFilter>
        </template>

        <template v-slot:item0="{ item }">
            <v-checkbox style="color: #114ef7;" hide-details v-model="checkboxStates[item.clientOrderId]"
                @change="valuesToGrouped(item.clientOrderId, checkboxStates[item.clientOrderId])">
            </v-checkbox>
        </template>
        <template v-slot:item1="{ item }">{{ item.fullName }} </template>
        <template v-slot:item2="{ item }">{{ item.productName }}</template>
        <template v-slot:item3="{ item }">{{ item.phoneNumber }}</template>
        <template v-slot:item4="{ item }">{{ item.numCommand }}</template>

        <template v-slot:item5="{ item }">{{ formatPrice(item.price) }}</template>
        <template v-slot:item6="{ item }">{{ item.quantity }}</template>
        <template v-slot:item7="{ item }">
            <StatusButton :title="getStatusLabel(item.orderStatus)" :color="getStatusColor(item.orderStatus)"
                disableIcon>
                <template v-slot:icon>
                    <svg v-if="item.orderStatus == 0" width="19" height="18" viewBox="0 0 19 18" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M15.1475 4.1475L4.6475 14.6475C4.6325 14.6625 4.625 14.67 4.61 14.6775C4.325 14.4375 4.0625 14.175 3.8225 13.89C2.6825 12.5775 2 10.8675 2 9C2 4.86 5.36 1.5 9.5 1.5C11.3675 1.5 13.0775 2.1825 14.39 3.3225C14.675 3.5625 14.9375 3.825 15.1775 4.11C15.17 4.125 15.1625 4.1325 15.1475 4.1475Z"
                            fill="white" />
                        <path
                            d="M16.9997 8.99965C16.9997 13.1172 13.6172 16.4997 9.49965 16.4997C8.37465 16.4997 7.30965 16.2522 6.34965 15.8022C5.88465 15.5847 5.79465 14.9621 6.15465 14.5947L15.0947 5.65465C15.4546 5.29465 16.0847 5.38465 16.3022 5.84965C16.7522 6.80215 16.9997 7.87465 16.9997 8.99965Z"
                            fill="white" />
                        <path
                            d="M16.8277 1.67266C16.6027 1.44766 16.2352 1.44766 16.0102 1.67266L2.17266 15.5177C1.94766 15.7427 1.94766 16.1102 2.17266 16.3352C2.28516 16.4402 2.42766 16.5002 2.57766 16.5002C2.72766 16.5002 2.87016 16.4402 2.98266 16.3277L16.8277 2.48266C17.0602 2.25766 17.0602 1.89766 16.8277 1.67266Z"
                            fill="white" />
                    </svg>
                    <svg v-else-if="item.orderStatus == 1" width="16" height="16" viewBox="0 0 16 16" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M12.9324 2.71988C9.99995 -0.212617 5.23745 -0.212617 2.30495 2.71988C-0.68005 5.70488 -0.62755 10.5724 2.45495 13.4974C5.30495 16.1899 9.92495 16.1899 12.7749 13.4974C15.8649 10.5724 15.9174 5.70488 12.9324 2.71988ZM10.8849 11.4874C9.98495 12.3424 8.79995 12.7699 7.61495 12.7699C6.42995 12.7699 5.24495 12.3424 4.34495 11.4874C4.11995 11.2699 4.11245 10.9174 4.32245 10.6924C4.53995 10.4674 4.89245 10.4599 5.11745 10.6699C6.48995 11.9674 8.73245 11.9749 10.1124 10.6699C10.3374 10.4599 10.6974 10.4674 10.9074 10.6924C11.1249 10.9174 11.1099 11.2699 10.8849 11.4874Z"
                            fill="white" />
                    </svg>
                    <svg v-else-if="item.orderStatus == 2" width="16" height="16" viewBox="0 0 16 16" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M12.9324 2.71988C9.99995 -0.212617 5.23745 -0.212617 2.30495 2.71988C-0.68005 5.70488 -0.62755 10.5724 2.45495 13.4974C5.30495 16.1899 9.92495 16.1899 12.7749 13.4974C15.8649 10.5724 15.9174 5.70488 12.9324 2.71988ZM10.8849 11.4874C9.98495 12.3424 8.79995 12.7699 7.61495 12.7699C6.42995 12.7699 5.24495 12.3424 4.34495 11.4874C4.11995 11.2699 4.11245 10.9174 4.32245 10.6924C4.53995 10.4674 4.89245 10.4599 5.11745 10.6699C6.48995 11.9674 8.73245 11.9749 10.1124 10.6699C10.3374 10.4599 10.6974 10.4674 10.9074 10.6924C11.1249 10.9174 11.1099 11.2699 10.8849 11.4874Z"
                            fill="white" />
                    </svg>
                    <svg v-else-if="item.orderStatus == 3" width="19" height="18" viewBox="0 0 19 18" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M15.1475 4.1475L4.6475 14.6475C4.6325 14.6625 4.625 14.67 4.61 14.6775C4.325 14.4375 4.0625 14.175 3.8225 13.89C2.6825 12.5775 2 10.8675 2 9C2 4.86 5.36 1.5 9.5 1.5C11.3675 1.5 13.0775 2.1825 14.39 3.3225C14.675 3.5625 14.9375 3.825 15.1775 4.11C15.17 4.125 15.1625 4.1325 15.1475 4.1475Z"
                            fill="white" />
                        <path
                            d="M16.9997 8.99965C16.9997 13.1172 13.6172 16.4997 9.49965 16.4997C8.37465 16.4997 7.30965 16.2522 6.34965 15.8022C5.88465 15.5847 5.79465 14.9621 6.15465 14.5947L15.0947 5.65465C15.4546 5.29465 16.0847 5.38465 16.3022 5.84965C16.7522 6.80215 16.9997 7.87465 16.9997 8.99965Z"
                            fill="white" />
                        <path
                            d="M16.8277 1.67266C16.6027 1.44766 16.2352 1.44766 16.0102 1.67266L2.17266 15.5177C1.94766 15.7427 1.94766 16.1102 2.17266 16.3352C2.28516 16.4402 2.42766 16.5002 2.57766 16.5002C2.72766 16.5002 2.87016 16.4402 2.98266 16.3277L16.8277 2.48266C17.0602 2.25766 17.0602 1.89766 16.8277 1.67266Z"
                            fill="white" />
                    </svg>
                    <svg v-else-if="item.orderStatus == 4" width="16" height="16" viewBox="0 0 16 16" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M7.7998 0.5C3.6673 0.5 0.299805 3.8675 0.299805 8C0.299805 12.1325 3.6673 15.5 7.7998 15.5C11.9323 15.5 15.2998 12.1325 15.2998 8C15.2998 3.8675 11.9323 0.5 7.7998 0.5ZM11.3848 6.275L7.1323 10.5275C7.0273 10.6325 6.8848 10.6925 6.7348 10.6925C6.5848 10.6925 6.4423 10.6325 6.33731 10.5275L4.2148 8.405C3.9973 8.1875 3.9973 7.8275 4.2148 7.61C4.4323 7.3925 4.7923 7.3925 5.0098 7.61L6.7348 9.335L10.5898 5.48C10.8073 5.2625 11.1673 5.2625 11.3848 5.48C11.6023 5.6975 11.6023 6.05 11.3848 6.275Z"
                            fill="white" />
                    </svg>
                </template>
            </StatusButton>
        </template>
        <template v-slot:edit="{ item }">
            <initializedDeliveryOrdersActionMenu :Id="index" v-bind:idOrder="item.clientOrderId"
                :deliveryCompanyId="item.deliveryCompanyId" :deliveryCompanyName="item.deliveryCompanyName"
                :IsAccepted="item.isAccepted" :getDeliveryOrders="fetchDeliveryOrders"
                :PickupPointLocation="PickupPointLocation" />
        </template>
    </gridComponent>
</template>

<script>
import GridComponent from '@/genericComponent/gridComponent.vue';
import ColumnFilter from '@/genericComponent/ColumnFilter.vue';
import StatusButton from '@/genericComponent/StatusButton.vue';
import initializedDeliveryOrdersActionMenu from './initializedDeliveryOrdersActionMenu.vue';
import { getinitializedDeliveryOrders, getAllPickupPointLocation, formatPrice } from "@/api/index";

export default {
    components: { StatusButton, GridComponent, ColumnFilter, initializedDeliveryOrdersActionMenu },
    props: {
        deliveryOrderId: {
            type: String,
            required: true,
        },
    },
    created() {
        const storedArray = JSON.parse(localStorage.getItem(`toGrouped//`)) || [];
        storedArray.forEach(name => {
            this.checkboxStates[name] = true;
        });
        this.$emit('GroupedClientOrder', storedArray);
    },
    mounted() {
        // this.fetchDeliveryOrders();
        this.getPickupPoint();
        this.emitter.emit('remise-search-at-null');
        this.emitter.on('event-test', (event) => {
            this.search = event;
            this.filters.SearchTitle = event;
            this.fetchDeliveryOrders();
        });
    },
    unmounted() {
        this.emitter.off('event-test');
        this.emitter.emit('remise-search-at-null');
    },
    data() {
        return {
            loader: true,
            page: 1,
            PageSize: 10,
            items: {},
            itemsData: {},
            filters: {
                SearchTitle: null,
                SearchQuantity: null,
                SearchTax: null,
                SearchPrice: null,
            },
            search: null,
            SortedBy: null,
            SortingType: null,
            item: null,
            PickupPointLocation: [],
            checkboxStates: {},
        }
    },
    methods: {
        formatPrice(price) {
            return formatPrice(price)
        },
        getPickupPoint() {
            getAllPickupPointLocation()
                .then((response) => {
                    this.PickupPointLocation = response.data;
                })
                .catch((error) => {
                    console.error(error);
                });
        },
        fetchDeliveryOrders(page = this.page) {
            const params = {
                PageNumber: page,
                PageSize: this.PageSize,
                SortBy: this.SortedBy,
                SortDescending: this.SortingType == "DESC" ? true : false,
                SearchTitle: this.filters.SearchTitle,
                SearchTerm: this.filters.SearchTerm,
            };

            getinitializedDeliveryOrders(params)
                .then((response) => {
                    this.items = response.data.items;
                    this.itemsData.numberOfPage = response.data.totalPages;
                    this.itemsData.totalItemsCount = response.data.totalCount;
                    this.itemsData.pageNumber = response.data.pageNumber;
                    this.itemsData.hasPreviousPage = response.data.hasPreviousPage;
                    this.itemsData.hasNextPage = response.data.hasNextPage;
                    this.loader = false;
                })
                .catch((error) => {
                    console.error('Error fetching delivery orders:', error);
                });
        },
        getStatusLabel(status) {
            switch (status) {
                case 0: return this.$t('Delivery.Status.Initialized');
                case 1: return this.$t('Delivery.Status.Assigned');
                case 2: return this.$t('Delivery.Status.Accepted');
                case 3: return this.$t('Delivery.Status.Rejected');
                case 4: return this.$t('Delivery.Status.Completed');
                default: return this.$t('Delivery.Status.Initialized');
            }
        },
        getStatusColor(status) {
            switch (status) {
                case 0: return '#BEBEBE';
                case 1: return '#3BBAFF';
                case 2: return '#3BBAFF';
                case 3: return '#F25C5C';
                case 4: return '#00CBA0';
                default: return this.$t('Delivery.Status.Initialized');
            }
        },
        valuesToGrouped(clientOrderId, isSelected) {
            const storageKey = `toGrouped//`;
            let array = JSON.parse(localStorage.getItem(storageKey)) || [];
            if (isSelected) {
                if (!array.includes(clientOrderId)) {
                    array.push(clientOrderId);
                }
            } else {
                array = array.filter(item => item !== clientOrderId);

                if (array.length === 0) {
                    localStorage.removeItem(storageKey);
                    this.$emit('GroupedClientOrder', array);
                    return;
                }
            }
            this.$emit('GroupedClientOrder', array);
            localStorage.setItem(storageKey, JSON.stringify(array));
        },
        removeGrouped() {
            const storageKey = `toGrouped//`;
            const storedArray = JSON.parse(localStorage.getItem(storageKey)) || [];
            storedArray.forEach(name => { this.checkboxStates[name] = false;});
            localStorage.removeItem(storageKey);
            this.$emit('GroupedClientOrder', []);
        }
    },
    computed: {
        headers() {
            const headers = [
                'Select',
                this.$t('Delivery.Order.Title'),
                this.$t('Delivery.Order.Quantity'),
                this.$t('Delivery.Order.Price'),
                this.$t('Delivery.Order.Tax'),
                this.$t('Delivery.status'),
                this.$t('Delivery.status'),
            ];
            return headers;
        },
        SlotsItems() {
            const items = {
                item0: 'item',
                item1: 'item',
                item2: 'item',
                item3: 'item',
                item4: 'item',
                item5: 'item',
            }
            let i = 0;
            for (const key in items) {
                items[key] = 'item' + i;
                i = i + 1;
            }
            return items;
        },
        SlotsFilters() {
            const filters = {
                Filter0: 'Filter',
                Filter1: 'Filter',
                Filter2: 'Filter',
                Filter3: 'Filter',
                Filter4: 'Filter',
                Filter5: 'Filter',
            }
            let i = 0;
            for (const key in filters) {
                filters[key] = 'Filter' + i;
                i = i + 1;
            }
            return filters;
        },
        colonneWidth() {
            const headers = ['20%', '15%', '15%', '20%', '20%', '15%'];
            return headers;
        },
    }
};
</script>

<style scoped>
.v-card-title {
    color: #001e50;
    font-size: 18px;
    line-height: 25.5px;
    font-weight: 700;
    font-family: inter;
}

.v-window .v-card-title {
    font-family: inter;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    color: #5b6d8e;
    margin-left: 12px;
    margin-bottom: 5px;
}

.slider {
    color: #667280;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    flex: content;
    pointer-events: none;
    border: none;
}
</style>
